import { render } from "./PostBody.vue?vue&type=template&id=e74c83c4&scoped=true"
import script from "./PostBody.vue?vue&type=script&lang=js"
export * from "./PostBody.vue?vue&type=script&lang=js"

import "./post-body.scss?vue&type=style&index=0&id=e74c83c4&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e74c83c4"]])

export default __exports__